angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsAccounts', function ($q, $log, EventManager, TeacherDataService) {
  return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '='
    },
    link: function (scope, element) {

      /**
       * THIS PAGE ONLY SHOWS UP TO THE USERS LISTED UNDER
       * teacher-students/ scope.showAccountsTab
       */

      var eventManager = new EventManager('teacherStudentsAccounts', scope);
      scope.flags = {
        loading: true,
        error: false,
        notSetup: false
      }
      scope.$watch('selectedClass', function(classroom){
        if(classroom){
          init(classroom.id)
        }
      })
      var init = function(classId){
        scope.flags.loading = true;
        scope.flags.error = false;
        scope.flags.notSetup = false;
        TeacherDataService.getC3ClassStudents_customForUser().then(function(classListWithPasswords){
            scope.classList = classListWithPasswords;
        }).then(function(){
          scope.flags.loading = false;
          scope.flags.error = false;
          scope.flags.notSetup = false;
        }).catch(function(){
          scope.flags.loading = false;
          scope.flags.error = false;
          scope.flags.notSetup = true;
        })
      }
    }
  }
});
